var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"12","sm":"11","md":"8"}},[_c('v-card',[_c('v-card-text',{staticClass:"text-body-2"},[_vm._v(" "+_vm._s(_vm.message)+" ")])],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }